"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _InteractionEngine_intersectionEngine, _InteractionEngine_logger, _InteractionEngine_managers, _InteractionEngine_uuidGenerator, _InteractionEngine_viewer;
Object.defineProperty(exports, "__esModule", { value: true });
exports.InteractionEngine = void 0;
const viewer_1 = require("@shapediver/viewer");
const gl_matrix_1 = require("gl-matrix");
const viewer_shared_services_1 = require("@shapediver/viewer.shared.services");
const IInteractionEngine_1 = require("../interfaces/IInteractionEngine");
const tsyringe_1 = require("tsyringe");
const viewer_rendering_engine_intersection_engine_1 = require("@shapediver/viewer.rendering-engine.intersection-engine");
class InteractionEngine {
    // #endregion Properties (5)
    // #region Constructors (1)
    constructor(viewer) {
        // #region Properties (5)
        _InteractionEngine_intersectionEngine.set(this, tsyringe_1.container.resolve(viewer_rendering_engine_intersection_engine_1.IntersectionEngine));
        _InteractionEngine_logger.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.Logger));
        _InteractionEngine_managers.set(this, {});
        _InteractionEngine_uuidGenerator.set(this, tsyringe_1.container.resolve(viewer_shared_services_1.UuidGenerator));
        _InteractionEngine_viewer.set(this, void 0);
        __classPrivateFieldSet(this, _InteractionEngine_viewer, viewer, "f");
        __classPrivateFieldGet(this, _InteractionEngine_viewer, "f").addCanvasEventListener(this);
    }
    // #endregion Constructors (1)
    // #region Public Methods (10)
    addInteractionManager(manager) {
        const token = __classPrivateFieldGet(this, _InteractionEngine_uuidGenerator, "f").create();
        __classPrivateFieldGet(this, _InteractionEngine_managers, "f")[token] = manager;
        manager.viewer = __classPrivateFieldGet(this, _InteractionEngine_viewer, "f");
        return token;
    }
    onKeyDown(event) { }
    onMouseDown(event) {
        const ray = this.mouseEventToRay(event);
        this.onDown(ray);
    }
    onMouseMove(event) {
        const ray = this.mouseEventToRay(event);
        this.onMove(ray);
    }
    onMouseEnd(event) { }
    onMouseUp(event) {
        const ray = this.mouseEventToRay(event);
        this.onEnd(ray, IInteractionEngine_1.INTERACTION_STATE.UP);
    }
    onMouseOut(event) {
        const ray = this.mouseEventToRay(event);
        this.onEnd(ray, IInteractionEngine_1.INTERACTION_STATE.OUT);
    }
    onMouseWheel(event) { }
    onTouchEnd(event) { }
    onTouchMove(event) {
        if (event.touches.length > 1)
            return;
        const touch = event.changedTouches[0];
        const ray = this.touchToRay(touch);
        this.onMove(ray);
    }
    onTouchStart(event) {
        if (event.touches.length > 1)
            return;
        const touch = event.changedTouches[0];
        const ray = this.touchToRay(touch);
        this.onDown(ray);
    }
    onTouchCancel(event) {
        if (event.touches.length > 1)
            return;
        const touch = event.changedTouches[0];
        const ray = this.touchToRay(touch);
        this.onEnd(ray, IInteractionEngine_1.INTERACTION_STATE.OUT);
    }
    onTouchUp(event) {
        if (event.touches.length > 1)
            return;
        const touch = event.changedTouches[0];
        const ray = this.touchToRay(touch);
        this.onEnd(ray, IInteractionEngine_1.INTERACTION_STATE.UP);
    }
    removeInteractionManager(token) {
        if (!__classPrivateFieldGet(this, _InteractionEngine_managers, "f")[token])
            return false;
        delete __classPrivateFieldGet(this, _InteractionEngine_managers, "f")[token];
        return true;
    }
    // #endregion Public Methods (10)
    // #region Private Methods (5)
    /**
     * Calculate the ray that is created by the mouse event and the camera.
     *
     * @param event
     * @returns
     */
    mouseEventToRay(event) {
        const rect = __classPrivateFieldGet(this, _InteractionEngine_viewer, "f").canvas.getBoundingClientRect();
        const camera = __classPrivateFieldGet(this, _InteractionEngine_viewer, "f").camera;
        if (!camera) {
            const error = new viewer_shared_services_1.ShapeDiverViewerGeneralError('InteractionEngine.mouseEventToRay: No camera is defined for this viewer.');
            throw __classPrivateFieldGet(this, _InteractionEngine_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.VIEWER, `InteractionEngine.mouseEventToRay`, error);
        }
        let _mouse_x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        let _mouse_y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        let origin = gl_matrix_1.vec3.clone(camera.position);
        let direction = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), camera.unproject(gl_matrix_1.vec3.fromValues(_mouse_x, _mouse_y, 0.5)), origin));
        return { origin, direction };
    }
    /**
     * Apply all filters for the intersection of the scene.
     * Call all according interaction managers with the results.
     *
     * @param ray
     */
    onDown(ray) {
        const filters = [];
        for (let m in __classPrivateFieldGet(this, _InteractionEngine_managers, "f"))
            filters.push(__classPrivateFieldGet(this, _InteractionEngine_managers, "f")[m].filter(IInteractionEngine_1.INTERACTION_STATE.DOWN));
        const intersection = __classPrivateFieldGet(this, _InteractionEngine_intersectionEngine, "f").intersect(ray, filters, viewer_1.api.sceneTree.root, __classPrivateFieldGet(this, _InteractionEngine_viewer, "f").id) || [];
        for (let m in __classPrivateFieldGet(this, _InteractionEngine_managers, "f"))
            __classPrivateFieldGet(this, _InteractionEngine_managers, "f")[m].onDown(ray, intersection);
    }
    /**
     * Apply all filters for the intersection of the scene.
     * Call all according interaction managers with the results.
     *
     * @param ray
     */
    onEnd(ray, endState) {
        const filters = [];
        for (let m in __classPrivateFieldGet(this, _InteractionEngine_managers, "f"))
            filters.push(__classPrivateFieldGet(this, _InteractionEngine_managers, "f")[m].filter(endState));
        for (let m in __classPrivateFieldGet(this, _InteractionEngine_managers, "f"))
            filters.push(__classPrivateFieldGet(this, _InteractionEngine_managers, "f")[m].filter(IInteractionEngine_1.INTERACTION_STATE.END));
        const intersection = __classPrivateFieldGet(this, _InteractionEngine_intersectionEngine, "f").intersect(ray, filters, viewer_1.api.sceneTree.root, __classPrivateFieldGet(this, _InteractionEngine_viewer, "f").id) || [];
        for (let m in __classPrivateFieldGet(this, _InteractionEngine_managers, "f"))
            __classPrivateFieldGet(this, _InteractionEngine_managers, "f")[m].onEnd(ray, intersection, endState);
    }
    /**
     * Apply all filters for the intersection of the scene.
     * Call all according interaction managers with the results.
     *
     * @param ray
     */
    onMove(ray) {
        const filters = [];
        for (let m in __classPrivateFieldGet(this, _InteractionEngine_managers, "f"))
            filters.push(__classPrivateFieldGet(this, _InteractionEngine_managers, "f")[m].filter(IInteractionEngine_1.INTERACTION_STATE.MOVE));
        const intersection = __classPrivateFieldGet(this, _InteractionEngine_intersectionEngine, "f").intersect(ray, filters, viewer_1.api.sceneTree.root, __classPrivateFieldGet(this, _InteractionEngine_viewer, "f").id) || [];
        for (let m in __classPrivateFieldGet(this, _InteractionEngine_managers, "f"))
            __classPrivateFieldGet(this, _InteractionEngine_managers, "f")[m].onMove(ray, intersection);
    }
    /**
     * Create the ray that is created by the touch event and the camera.
     *
     * @param event
     * @returns
     */
    touchToRay(event) {
        const rect = __classPrivateFieldGet(this, _InteractionEngine_viewer, "f").canvas.getBoundingClientRect();
        const camera = __classPrivateFieldGet(this, _InteractionEngine_viewer, "f").camera;
        if (!camera) {
            const error = new viewer_shared_services_1.ShapeDiverViewerGeneralError('InteractionEngine.touchToRay: No camera is defined for this viewer.');
            throw __classPrivateFieldGet(this, _InteractionEngine_logger, "f").handleError(viewer_shared_services_1.LOGGINGTOPIC.VIEWER, `InteractionEngine.touchToRay`, error);
        }
        let _mouse_x = ((event.clientX - rect.left) / rect.width) * 2 - 1;
        let _mouse_y = -((event.clientY - rect.top) / rect.height) * 2 + 1;
        let origin = gl_matrix_1.vec3.clone(camera.position);
        let direction = gl_matrix_1.vec3.normalize(gl_matrix_1.vec3.create(), gl_matrix_1.vec3.sub(gl_matrix_1.vec3.create(), camera.unproject(gl_matrix_1.vec3.fromValues(_mouse_x, _mouse_y, 0.5)), origin));
        return { origin, direction };
    }
}
exports.InteractionEngine = InteractionEngine;
_InteractionEngine_intersectionEngine = new WeakMap(), _InteractionEngine_logger = new WeakMap(), _InteractionEngine_managers = new WeakMap(), _InteractionEngine_uuidGenerator = new WeakMap(), _InteractionEngine_viewer = new WeakMap();
//# sourceMappingURL=InteractionEngine.js.map